import { render, staticRenderFns } from "./PageMetrics.vue?vue&type=template&id=5e519772&scoped=true&"
import script from "./PageMetrics.vue?vue&type=script&setup=true&lang=js&"
export * from "./PageMetrics.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PageMetrics.vue?vue&type=style&index=0&id=5e519772&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e519772",
  null
  
)

export default component.exports